import React from "react";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import { ProductCheckboxList } from "components/ProductCheckboxList";
import { routes } from "utilities/routing/generatedRoutes";
import { getInvoiceV1NewSections } from "invoice/getInvoiceV1NewSections";
import { useInvoiceV1NewForm } from "invoice/hooks";
import { formatWrittenDayMonthYear } from "utilities";
import { Status, StatusDropdown } from "components";
import { ShowTitle } from "show/detail/ShowTitle";

interface Props {
  viewModel: server.viewmodel.ShowNewDocumentFrontModel;
}

export const NewInvoiceV1FromShowEditSection = (props: Props) => {
  const { viewModel } = props;
  const { show } = viewModel;

  const hook = useInvoiceV1NewForm({
    initialAddressee: show.promoter,
    initialContact: show.promoterContact,
    initialCurrency: show.currency,
    initialCostCenter: show.costCenter,
    initialExchangeRate: 1, // Exchange rate is unknown until bookkeeping is selected
    isDocumentFromShow: true,
  });
  const [selectedProducts, setSelectedProducts] = React.useState<number[]>(viewModel.products.filter(p => p.sales?.totalExVat.amount > 0).map(p => p.productId));
  const [showStatus, setShowStatus] = React.useState(viewModel.show.status);

  const submit = async () => {
    return window.CoreApi.Invoice.CreateInvoiceV1FromShow({
      invoice: {
        exchangeRate: hook.exchangeRate,
        isDraft: hook.isDraft,
        ownerUserId: hook.owner.userId,
        invoiceDate: hook.invoiceDate.toDate(),
        bookkeepingId: hook.bookkeeping.bookkeepingId,
        addresseeCompanyId: hook.addressee.companyId,
        contactId: hook.contact?.contactId,
        currency: hook.currency,
        dueInDays: hook.dueInDays,
        bankAccountId: hook.bankAccount?.bankAccountId,
        costCenterId: hook.costCenter?.costCenterId,
        concerning: hook.concerning,
      } as Required<server.dto.CreateInvoiceV1Instruction>,
      selectedProducts: selectedProducts,
      showStatusId: showStatus.statusId,
      showId: show.showId,
    });
  };

  return <EditSectionTemplate
    submit={submit}
    redirectUrl={(itemId) => routes.invoiceV1_Detail(itemId).absolute}
    sections={[{
      key: "show",
      type: "regular",
      title: site.currentEnvironment.show.singular,
      fields: [{
        key: "showDate",
        label: RESX.DateTime.lblDate,
        renderEditNew: () => (
          <div className="main-section-template-fields-padding">
            <div>{formatWrittenDayMonthYear(show.dateTime.startDisplay)}</div>
          </div>
        )
      }, {
        key: "showName",
        label: RESX.Show.resxShow,
        renderEditNew: () => (
          <div className="main-section-template-fields-padding">
            <ShowTitle show={show} />
          </div>
        )
      }, {
        key: "showStatus",
        label: RESX.Status.resxStatus,
        renderEditNew: () => (
          show.locked === "locked"
            ? <div className="main-section-template-fields-padding">
              <Status status={show.status} />
            </div>
            : <StatusDropdown
              mainArea="show"
              value={showStatus}
              onChange={setShowStatus}
              options={undefined}
            />
        )
      }]
    },
    getInvoiceV1NewSections(hook, { alwaysShowCurrency: true }),
    {
      key: "products",
      type: "regular",
      title: RESX.Product.Products,
      fields: [{
        key: "products",
        label: RESX.Product.Products,
        renderEditNew: () => (
          viewModel.products.length === 0
            ? <div className="ui message red">{RESX.Document.TryingToAddDocumentWithoutAddingProductAndServiceItems}</div>
            : <ProductCheckboxList
              products={viewModel.products}
              selectedProducts={selectedProducts}
              setSelectedProducts={setSelectedProducts}
            />
        )
      }]
    }]} />;
};

export default NewInvoiceV1FromShowEditSection;
